var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFast = function SvgFast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.667 4 13.87 16.313c-.389.545-.584.818-.575 1.045a.667.667 0 0 0 .259.503c.18.139.515.139 1.184.139h6.594L20 28l8.795-12.313c.39-.545.584-.818.576-1.045a.666.666 0 0 0-.26-.503C28.932 14 28.598 14 27.928 14h-6.594l1.334-10Z",
    stroke: "#4A49BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23.333H4.667m4-7.333h-6M12 8.667H5.333",
    stroke: "#06B559"
  }))));
};
export default SvgFast;